import { render, staticRenderFns } from "./ModalPlatformComponents.vue?vue&type=template&id=60b431f4&"
import script from "./ModalPlatformComponents.vue?vue&type=script&lang=js&"
export * from "./ModalPlatformComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports